export default "__VITE_ASSET__DbZe4D7h__"